<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
import {getPortalInfo} from "./api/system";

export default {
  name: 'App',

  provide() {
    return {
      reload: this.reload
    }
  },

  data() {
    return {
      isRouterAlive: true
    }
  },

  methods: {
    reload() {
      this.isRouterAlive = false;
      window.scrollTo(0, 0);
      this.$nextTick(() => {
        this.isRouterAlive = true;
      })
    },

    changeFavicon(url) {
      if (url == null || url === '') {
        return;
      }
      const link = document.querySelector("linl[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = url;
      document.getElementsByTagName('head')[0].appendChild(link);
    },

    getPortalDetail() {
      getPortalInfo().then(response => {
        const data = response.data || {};
        this.changeFavicon(data.favicon);
      })
    }
  },

  created() {
    this.getPortalDetail();
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue